/**
 * Which readiness question the fan page asks before offering online payment.
 *
 * The seller is the kiosk's organization, not the club whose page it is: a
 * caterer at a venue is ready (Stripe active, business info complete) or not
 * on its own account. Without a kiosk (a preview with no venue) the club's own
 * readiness is the best available answer.
 */
export type OnlineReadinessCall =
  | { fn: 'get_operator_online_payment_status'; args: { _operator_id: string } }
  | { fn: 'get_club_online_payment_status'; args: { _club_id: string } };

export function onlineReadinessCall(operatorId: string | null, clubId: string | null): OnlineReadinessCall | null {
  if (operatorId) return { fn: 'get_operator_online_payment_status', args: { _operator_id: operatorId } };
  if (clubId) return { fn: 'get_club_online_payment_status', args: { _club_id: clubId } };
  return null;
}
